import React from 'react';
import CategoriesTable from '../components/CategoriesTable';

export function Categories() {
  return <CategoriesTable />;
}
